import { render, staticRenderFns } from "./AssessmentChildren.vue?vue&type=template&id=2ded84c0"
import script from "./AssessmentChildren.vue?vue&type=script&lang=js"
export * from "./AssessmentChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports